
import { lazyLoad } from "../utils/lazyLoad";
import { RoutesPath } from "./RoutesPath";
// import Service from "../pages/Services";
const Commodity = lazyLoad(() => import('../pages/commodity'))
const TermsAndCondition = lazyLoad(() => import('../pages/policy/TermsAndCondition'));
const RefundPolicy = lazyLoad(() => import('../pages/policy/RefundPolicy.js'));
const PrivacyPolicy = lazyLoad(() => import('../pages/policy/PrivacyPolicy.js'));
const ContactUs = lazyLoad(() => import('../pages/policy/ContactUs.js'));
const MobileHome = lazyLoad(() => import('../pages/commoditymobileapp/MobileHome.js'));

const routes = [
  {
    path: RoutesPath.HOME,
    element: Commodity,
  },
  {
    path: RoutesPath.TERMSANDCONDITION,
    element: TermsAndCondition,
  },
  {
    path: RoutesPath.REFUNDPOLICY,
    element: RefundPolicy,
  },
  {
    path: RoutesPath.PRIVACYPOLICY,
    element: PrivacyPolicy,
  },
  {
    path: RoutesPath.CONTACTUS,
    element: ContactUs,
  },
  {
    path: RoutesPath.COMMODITYMOBILEAPP,
    element: MobileHome,
  },
];

export default routes;
